import _isNumber from 'lodash/isNumber'

export const isValidNumber = (value?: number | string): boolean => {
  if (isNaN(Number(value))) {
    return false
  }
  return _isNumber(Number(value))
}
